import { supabase } from '../supabaseClient';

export const orderService = {
  generateOrderNumber() {
    const prefix = 'A1S';
    const timestamp = Date.now().toString().slice(-6);
    const random = Math.floor(1000 + Math.random() * 9000);
    return `${prefix}-${timestamp}-${random}`;
  },

  async createOrder(orderPayload) {
    const orderNumber = this.generateOrderNumber();
    const orderData = {
      ...orderPayload,
      order_number: orderNumber,
      status: 'Pending',
      created_at: new Date().toISOString()
    };

    const { data, error } = await supabase
      .from('orders')
      .insert([orderData])
      .select()
      .single();

    if (error) {
      const detail = [error.message, error.details, error.hint].filter(Boolean).join(' ');
      throw new Error(detail || 'Supabase rejected the order. Check the orders table schema.');
    }

    await supabase.from('order_status_history').insert([{
      order_id: data.id,
      status: 'Pending',
      notes: 'Order placed by customer'
    }]);

    return data;
  },

  async trackOrder(orderNumber, phone) {
    const lookupValue = (orderNumber || phone || '').trim();
    const column = orderNumber ? 'order_number' : 'phone';

    if (!lookupValue) return null;

    const { data, error } = await supabase
      .from('orders')
      .select('*')
      .ilike(column, lookupValue)
      .maybeSingle();

    if (error) throw error;
    return data || null;
  },

  async getAllOrdersAdmin() {
    const { data, error } = await supabase
      .from('orders')
      .select('*')
      .order('created_at', { ascending: false });

    if (error) throw error;
    return data || [];
  },

  async updateOrderStatus(orderId, newStatus) {
    const { data, error } = await supabase
      .from('orders')
      .update({ status: newStatus, updated_at: new Date().toISOString() })
      .eq('id', orderId)
      .select()
      .single();

    if (error) throw error;

    await supabase.from('order_status_history').insert([{
      order_id: orderId,
      status: newStatus,
      notes: `Status updated by Admin to ${newStatus}`
    }]);

    return data;
  }
};